export default __webpack_public_path__ + "static/media/d.3ebe1530.png";